import React from "react";
import styles from "./adminheader.module.css";
import logo from "./../../assets/logo.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function AdminHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <nav className={`navbar navbar-expand-lg navbar-light ${styles.headbar}`}>
      <div className="container-fluid">
        <img loading="lazy" className={styles.imglogo} src={logo} alt="img-logo" />
        <button
          className={`navbar-brand ${styles.textlogo}`}
          onClick={() => navigate("/")}
        >
          bHive
        </button>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a href="#" className={`nav-link ${styles.right1}`}>
                {t("help")}
              </a>
            </li>
            <li className="nav-item">
              <button onClick={() => navigate("/faq")} className={`nav-link ${styles.right1}`}>
                {t("FAQ")}
              </button>
            </li>
            <li className="nav-item">
              <button
                onClick={() => navigate("/terms-of-service")}
                className={`nav-link ${styles.right1}`}
              >
                {t("terms")}
              </button>
            </li>
            <li className="nav-item">
              <button onClick={() => navigate("/privacy-policy")} className={`nav-link ${styles.right1}`}>
                {t("privacy")}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
